/**
 * Application-wide constants.
 * All environment variables are accessed here — never inline them in components.
 *
 * SECURITY: Only VITE_ prefixed vars are exposed to the browser bundle.
 * Never expose the Supabase service-role key here (AGENTS.md §5).
 */

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export const APP_NAME = 'PetNoter';
export const APP_VERSION = '0.1.0';

/** Supported pet species */
export const PET_SPECIES = ['dog', 'cat', 'bird', 'rabbit', 'other'] as const;

/** Supported medical record types */
export const RECORD_TYPES = ['vaccine', 'prescription', 'lab'] as const;

/** Basic Vault (freemium) limits — Premium has unlimited pets/documents */
export const BASIC_VAULT_MAX_PETS = 1;
export const BASIC_VAULT_MAX_DOCUMENTS = 10;
